import { render, staticRenderFns } from "./ConsultantPanel.vue?vue&type=template&id=799fa47e&scoped=true&"
import script from "./ConsultantPanel.vue?vue&type=script&lang=js&"
export * from "./ConsultantPanel.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantPanel.vue?vue&type=style&index=0&id=799fa47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799fa47e",
  null
  
)

export default component.exports